import axios from 'axios'
import apiConfig from 'utilities/apiConfig'

export function fetchGlobals() {
    return (dispatch) => {
        dispatch({ type: 'FETCH_GLOBALS' })
        axios
            .get(`${process.env.API_URL}/api/globals/recommendedCategories`, apiConfig)
            .then((response) => {
                dispatch({
                    type: 'FETCH_GLOBALS_SUCCESS',
                    payload: response.data,
                })
            })
            .catch((err) => dispatch({ type: 'FETCH_GLOBALS_FAILED', payload: err }))
    }
}
